<template>
		<div class="message-bubble bot-container">
			<v-card>
				<v-card-subtitle primary-title>
					Puedes agregar los siguientes extras:
				</v-card-subtitle>
				<v-card-text>
					<v-container>
						<v-row v-for="(p, key) in extras" :key="key" @click="add(p)">
							<v-btn color="var(--app-button)" block class="btn-extra button-rounding">
								{{ p.name }} - ${{ p.price }}
							</v-btn>
						</v-row>
					</v-container>
				</v-card-text>
				<v-card-actions>
					<v-row justify="space-between" no-gutters>
						<v-col cols="12" sm="5">
							<BackBtn block :return_to="'product'" :text="true" />
						</v-col>
						<v-col cols="12" sm="5">
							<v-btn class="bot-btn-action button-rounding" block @click="continuar" dark>
								<v-icon left>mdi-credit-card</v-icon>
								Continuar
							</v-btn>
						</v-col>
					</v-row>
				</v-card-actions>
			</v-card>
		<div class="extra-snack-container">
			<v-snackbar absolute v-model="snackbar">
				{{ snack_text }}
				<template v-slot:action="{ attrs }">
					<v-btn class="button-rounding" color="info" icon v-bind="attrs" @click="snackbar = false">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</template>
			</v-snackbar>
		</div>
		</div>
</template>

<script>
import BackBtn from "./BackBtn";
export default {
	components: {
		BackBtn,
	},
	data: () => ({
		snackbar: false,
		snack_text: "",
	}),
	computed: {
		extras: {
			get() {
				return this.$store.getters["chatStore/get_extras"];
			},
		},
	},
	methods: {
		add(value) {
			value.quantity = 1;
			value.qtt = 1; //quantity
			value.type = "extra";
			this.$store.dispatch("chatStore/add_to_cart", {
				data: value,
				type: "extra",
			});
			// this.snackbar = true;
			// this.snack_text = `Se ha agregado ${value.name} a su compra`;
		},
		continuar() {
			this.$store.commit("chatStore/STATUS", "check-email");
		},
	},
};
</script>

<style lang="scss">
.bot-container {
	.btn-extra {
		color: var(--app-button-text)!important;
		margin: 10px 0;
		max-width: 100%;
	}
}
</style>
